const TOOLTIP_CONFIG = {
  shared: true,
  intersect: false,
  x: {
    show: true,
  },
};

export default class TooltipConfigBuilder {
  #config = { ...TOOLTIP_CONFIG };

  build() {
    return this.#config;
  }
}
